import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import React from 'react'

import T from 'T'

import type { CloseButtonProps } from 'react-toastify'

/**
 * The dismiss for notification toasts. Larger than toastify's own and centred at the end of the row:
 * these stay up until they are read or closed, so the close is a control the user reaches for rather
 * than a corner decoration on something about to vanish on its own.
 */
const NotificationToastCloseButton = ({ closeToast }: CloseButtonProps) => (
  <IconButton
    aria-label={T.CLOSE}
    size="small"
    // `ml: auto` pins it to the toast's right edge whatever the content's width, rather than letting it
    // trail a short title; centred so it reads as the row's control rather than a corner mark.
    sx={{ alignSelf: 'center', ml: 'auto', color: 'text.secondary', flexShrink: 0 }}
    onClick={closeToast}
  >
    <CloseIcon fontSize="medium" />
  </IconButton>
)

export default NotificationToastCloseButton
